import auditIcon from '@/assets/images/audit_icon.svg';
import contractIcon from '@/assets/images/contract-icon.svg';
import planIcon from '@/assets/images/health-svgrepo-com.svg';
import cadastralDataMatchingIcon from '@/assets/images/profile-user.svg';
import vittaIcon from '@/assets/images/vwing.svg';
import moneySignIcon from '@/assets/images/money-sign.svg';
import hourglass from '@/assets/images/material-symbols_hourglass-outline.svg';

const ICONS = {
  ADDRESS: 'pin-outline',
  ATTENDANCE: 'message-square-outline',
  ATTACHMENTS: 'attach-outline',
  AUDIT: auditIcon,
  COMPANY: 'briefcase-outline',
  COMPANY_GROUP: 'grid-outline',
  BENEFICIARIES: 'people-outline',
  PERSON: 'person-outline',
  CADASTRAL_POSITION: 'file-text-outline',
  FAMILY_GROUP: 'people-outline',
  UPLOAD: 'cloud-upload-outline',
  CONTRACT: contractIcon,
  CONTRACT_DATA: 'book-open-outline',
  NEGOTIATION: 'inbox-outline',
  MOVE: 'flip-2-outline',
  FLIP: 'flip-2-outline',
  USERS: 'people-outline',
  USER: 'person-outline',
  DETAILS: 'eye-outline',
  FINANCIAL_ADJUSTMENTS: 'options-outline',
  LOGOUT: 'log-out-outline',
  PLAN: planIcon,
  RULES: 'book-outline',
  CADASTRAL_DATA_MATCHING: cadastralDataMatchingIcon,
  DOWNLOAD: 'download-outline',
  SEARCH: 'search-outline',
  REMOVE: 'trash-2-outline',
  LINK: 'external-link-outline',
  LINK_CHAIN: 'link-2-outline',
  VITTA: vittaIcon,
  WARNING: 'alert-triangle-outline',
  HELP: 'question-mark-circle-outline',
  FILE_VALIDATION: 'trending-up-outline',
  INFO: 'info-outline',
  FILE_UPLOAD: 'file-outline',
  ALERT: 'alert-circle-outline',
  CLOCK: 'clock-outline',
  ARROW_DOWN: 'arrow-ios-downward-outline',
  ARROW_UP: 'arrow-ios-upward-outline',
  CHECK_CIRCLE: 'checkmark-circle-outline',
  CHECK: 'checkmark-outline',
  SYNC: 'sync-outline',
  EDIT: 'edit-outline',
  MONEY_SIGN: moneySignIcon,
  CLOSE: 'close-outline',
  SEND: 'paper-plane-outline',
  FOLDER: 'folder-outline',
  MAGNIFIER: 'search-outline',
  COPY: 'copy-outline',
  HOURGLASS: hourglass,
  LEAD_INDICATION: 'heart-outline',
  TRENDING_UP: 'trending-up-outline',
  CUSTOMIZATION: 'pantone-outline',
  SHIELD: 'shield-outline',
  IMAGES: 'image-outline',
  TRASH: 'trash-2-outline',
  CROP: 'crop-outline',
  BULB: 'bulb-outline',
};

export default ICONS;
